const orgChartNodeTheme = {
    cardHeaderStylePref: {
        padding: 0,
        border: "0px solid black",
        paddingRight: "6px",
        position: "absolute",
        top: "3px",
        right: "34px",
    },
    avatarStyle: {
        width: 70,
        height: 70,
        position: "absolute",
        top: "0px",
        bottom: "0px",
        left: "-30px",
        border: "2px solid #019BD9",
        padding: "2px",
        margin: "auto",
        backgroundColor: "white",
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            boxShadow: '0 0 0 1px #019BD9',
        },
        cursor: 'pointer',
    },
    avatarStyleSmall: {
        width: 35,
        height: 35,
        position: "absolute",
        top: "0px",
        bottom: "0px",
        left: "5px",
        border: "1px solid #019BD9",
        padding: "2px",
        margin: "auto",
        backgroundColor: "white",
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            boxShadow: '0 0 0 1px #019BD9',
        },
        cursor: 'pointer',
    },

    gridContainer: {
        paddingLeft: "42px",
        textAlign: "left",
        paddingTop: "10px",
        paddingRight: "25px",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        border: "0px solid black"
    },
    gridContainerSmall: {
        paddingLeft: "46px",
        textAlign: "left",
        paddingTop: "12px",
        paddingRight: "25px",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        border: "0px solid black"
    },
    cardContent: {
        marginTop: "-10px",
        border: "0px solid black",
        textAlign: "left",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        paddingLeft: "42px",
        paddingTop: "12px",
        paddingRight: "25px",
    },
    cardContentSmall: {
        marginTop: "-10px",
        border: "0px solid black",
        textAlign: "left",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        paddingLeft: "46px",
        paddingTop: "12px",
        paddingRight: "25px",
    },
    zoomButtonsContainer: {
        position: "absolute",
        bottom: "5%",
        left: "45%",
        right: "auto",
        display: "flex",
        flexDirection: "row",
    }
}

export default orgChartNodeTheme